import { useMemo, useEffect } from 'react';
import {
  useSelector as useSelectorRedux,
  useDispatch as useDispatchRedux,
} from 'react-redux';
import { selectors, useDispatch, useSelector, utils } from '@lib/azgaz-ui/connect';

import { config, removeOfficeFromUrl, WidgetMode } from '@/utils';
import { getDealers } from '@/selectors';
import { actions } from '@/apps/appCreator/store/dealers';
import filtersConfig from '@/apps/dealer/filtersConfig';

type TProps = {
  form: any;
};

export default function useInitFilter({ form }: TProps) {
  const dispatch = useDispatch();
  const dispatchRedux = useDispatchRedux();

  const cars = useSelector(selectors.getCars);
  const { dealers } = useSelectorRedux(getDealers);

  const isDealerMode = WidgetMode.isDealerMode();

  const filters = useSelector(selectors.getFiltersValues);

  const uiHelper = useMemo(() => {
    return new utils.UiHelper({
      filters,
      form,
      dispatch,
    });
  }, [filters, form, dispatch]);

  useEffect(() => {
    if (!cars) {
      uiHelper.initFilters();
    }
    if (!dealers) {
      dispatch(actions.getDealers());
    }
    if (isDealerMode) {
      const resolvedDealerId =
        filtersConfig.dealerIn.defaultVal[0] || config.get('dealer');
      dispatchRedux(actions.dealerSelected(resolvedDealerId));
    }
    removeOfficeFromUrl();
  }, []);

  return {
    form,
    uiHelper,
  } as const;
}
